var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg37(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down arrow / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0036 9.1736C16.8162 8.98735 16.5628 8.88281 16.2986 8.88281C16.0344 8.88281 15.781 8.98735 15.5936 9.1736L12.0036 12.7136L8.46361 9.1736C8.27625 8.98735 8.0228 8.88281 7.75861 8.88281C7.49442 8.88281 7.24097 8.98735 7.05361 9.1736C6.95988 9.26657 6.88549 9.37717 6.83472 9.49903C6.78395 9.62089 6.75781 9.75159 6.75781 9.88361C6.75781 10.0156 6.78395 10.1463 6.83472 10.2682C6.88549 10.39 6.95988 10.5006 7.05361 10.5936L11.2936 14.8336C11.3866 14.9273 11.4972 15.0017 11.619 15.0525C11.7409 15.1033 11.8716 15.1294 12.0036 15.1294C12.1356 15.1294 12.2663 15.1033 12.3882 15.0525C12.51 15.0017 12.6206 14.9273 12.7136 14.8336L17.0036 10.5936C17.0973 10.5006 17.1717 10.39 17.2225 10.2682C17.2733 10.1463 17.2994 10.0156 17.2994 9.88361C17.2994 9.75159 17.2733 9.62089 17.2225 9.49903C17.1717 9.37717 17.0973 9.26657 17.0036 9.1736Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg37);
export default __webpack_public_path__ + "static/media/svg37.673006b93b99a0fd4faac0e0b8524495.svg";
export { ForwardRef as ReactComponent };